import {throttle} from 'throttle-debounce';
import m from '../helpers/metrics';
var h = require('../helpers/helpers');
var share_btns = document.getElementsByClassName('js-sharePopout');
require('./socialShare');

// Controls the sharePopout
// ------------------------------------------------------
function sharePopout(el) {
  var btn = el;
  var btn_pos;
  var pos_fixed; // Set to true if element position remains consistent with the viewport
  var above_class = 's-above'; // State class
  var below_class = 's-below'; // State class
  var open_class = 's-open'; // State class

  // Positions the menu to maintain visibility
  // ------------------------------------------------------
  function setAbove() {
    btn.classList.remove(below_class);
    btn.classList.add(above_class);
  }

  function setBelow() {
    btn.classList.add(below_class);
    btn.classList.remove(above_class);
  }

  // Checking logic
  // ------------------------------------------------------
  function checkOrientation() {
    var view_center = (m('win_height') / 2 + m('scroll_y')) / 2;

    // Flip the menu above the button if the bottom is in the bottom half of the viewport
    if (btn_pos > view_center) {
      setAbove();
    }
    else if (btn_pos < view_center) {
      setBelow();
    }
  }

  // Updates element position
  // ------------------------------------------------------
  function updateElementDims() {
    var cur_btn_pos = btn.getBoundingClientRect().top;

    if (cur_btn_pos !== btn_pos) {
      btn_pos = cur_btn_pos;
      pos_fixed = false;
    }
    else {
      pos_fixed = true;
    }
  }


  // Close menu when clicking outside the dropdown
  // ------------------------------------------------------
  function closeMenu() {
    btn.classList.remove(open_class);
  }

  function closeMenuLogic(ev) {
    if (ev.target !== btn && !h.isDescendant(btn, ev.target)) {
      closeMenu();
    }
  }

  // Open menu when clicking the nav button
  // ------------------------------------------------------
  function openMenu() {
    btn.classList.toggle(open_class);
  }

  // Event handling
  // ------------------------------------------------------
  function onResize() {
    closeMenu();
    updateElementDims();
    checkOrientation();
  }

  function onScroll() {
    closeMenu();
    updateElementDims();
    checkOrientation();
  }

  var onResize__throttled = throttle(100, onResize);
  var onScroll__throttled = throttle(200, onScroll);

  // Bind the events
  // ------------------------------------------------------
  function bindEvents() {
    window.addEventListener('scroll', onScroll__throttled);
    window.addEventListener('resize', onResize__throttled);

    // Standard menu clicks
    btn.addEventListener('click', openMenu);

    // Close the menu when clicking outside of it
    window.addEventListener('click', closeMenuLogic);
    window.addEventListener('touchstart', closeMenuLogic);  // else event never fires
  }

  // Kickoff
  // ------------------------------------------------------

  // Get and set initial values
  onResize();
  onScroll();

  // Bind events
  bindEvents();
}

// Check for element existence prior to execution
Array.from(share_btns || []).forEach(sharePopout);

